<template>
  <div>
    <b-container fluid class="d-flex align-items-center back-wrapper">
          <b-row >
            <b-col lg="7" md="10">
              <router-link :to="{name: 'areas'}" class="back-item">
                  <img class="arrow-back" src="img/theme/icn_arrowback.svg" alt="">
                  <span>Areas</span>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
    <div class="header pb-8 pt-5 pt-lg-6 d-flex align-items-center profile-header">

      <b-container fluid>
        <!-- Mask -->
        <span class="mask"></span>
        <!-- Header container -->
        <h1 class="text-center">Panel de Configuración</h1>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header" >
              <b-col cols="8">
                <h3 class="mb-0">Editar área</h3>
              </b-col>
            </b-row>

            <b-form @submit.prevent="updateProfile">
              <base-alert v-if="success === true" type="success" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Bien hecho!</strong> El área se creo existosamente.
              </base-alert>
              <base-alert v-if="success === false" type="danger" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Error!</strong> {{error}}
              </base-alert>
              <h6 class="heading-small text-muted mb-4">Información del área</h6>

              <div class="pl-lg-4" :key="reload">
                <b-row>
                  <b-col lg="6" class="mb-4">
                    <base-input
                      type="text"
                      label="Nombre del área"
                      placeholder="Nombre"
                      v-model="nameArea"
                      name="Nombre"
                      required
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6" class="mb-4">
                    <label class="form-control-label" for="">Hospitales</label>
                    <multiselect
                      :show-labels="false"
                      v-model="hospitalList"
                      :options="hospitals"
                      :multiple="false"
                      placeholder='Selecciona el hospital a asignar'
                      label="name"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4"/>

                <h6 v-show="pagedTableData" class="heading-small text-muted mb-4">Modelos asignados</h6>
                <el-table  v-show="pagedTableData" class="table-responsive table"
                          header-row-class-name="thead-light"
                          :data="pagedTableData"
                          :key="modelsCollab.length">
                    <el-table-column label="Modelo"
                              prop="name">
                        <template v-slot="{row}">
                            <b-media no-body class="align-items-center">
                                {{row.model}}
                            </b-media>
                        </template>
                    </el-table-column>
                    <el-table-column label="Color"
                          prop="area">
                          <template v-slot="{row}">
                              <b-media no-body >
                                {{ row.color }}
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label="Género"
                                prop="area">
                          <template v-slot="{row}">
                              <b-media no-body >
                                {{ row.gender }}
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label="Tipo"
                                prop="area">
                          <template v-slot="{row}">
                              <b-media no-body >
                                {{ row.type }}
                              </b-media>
                          </template>
                      </el-table-column>

                    <el-table-column label=""
                              prop=""
                              width="80px"
                              style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;"
                              >
                        <template v-slot="{row}">
                            <b-media no-body class="align-items-center">
                              <a class="page-link" v-on:click="deleteElement(row.id)" ><img src="img/theme/icn_delete.svg" alt=""></a>
                            </b-media>
                        </template>
                    </el-table-column>
                </el-table>
                <b-card-footer v-show="pagedTableData" class="py-4 d-flex justify-content-end">
                    <base-pagination v-model="currentPage" :per-page="10" @change="setPage"  :total="modelsCollab.length"></base-pagination>
                </b-card-footer>


                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Filipina Caballero</h6>
                <b-row v-for="(element, index) in arrayScrubs" :key="index+'ScrubC'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Hombre').scrub"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Pantalon Caballero</h6>
                <b-row v-for="(element, index) in arrayPants" :key="index+'PantsC'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Hombre').pants"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Chamarra Caballero</h6>
                <b-row v-for="(element, index) in arrayJackets" :key="index+'JacketC'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Hombre').jacket"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Gorro Caballero</h6>
                <b-row v-for="(element, index) in arrayCaps" :key="index+'CapsC'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Hombre').caps"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Calzado Caballero</h6>
                <b-row v-for="(element, index) in arrayShoes" :key="index+'ShoesC'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Hombre').shoes"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Bata Caballero</h6>
                <b-row v-for="(element, index) in arrayCoat" :key="index+'coatC'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Hombre').coat"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Filipina Dama</h6>
                <b-row v-for="(element, index) in arrayScrubsW" :key="index+'ScrubD'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Mujer').scrub"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Pantalon Dama</h6>
                <b-row v-for="(element, index) in arrayPantsW" :key="index+'PantsD'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Mujer').pants"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Chamarra Dama</h6>
                <b-row v-for="(element, index) in arrayJacketsW" :key="index+'JacketD'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Mujer').jacket"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Gorro Dama</h6>
                <b-row v-for="(element, index) in arrayCapsW" :key="index+'CapsC'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Mujer').caps"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Calzado Dama</h6>
                <b-row v-for="(element, index) in arrayShoesW" :key="index+'ShoesD'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Mujer').shoes"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Bata Dama</h6>
                <b-row v-for="(element, index) in arrayCoatW" :key="index+'coatD'">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.model"
                      :options="hasClothesType('Mujer').coat"
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="element.color"
                      :options="getColors(element.model)"
                      placeholder='Selecciona el color'>
                    </multiselect>
                  </b-col>
                </b-row>

              </div>
              <hr class="my-4">
              <b-button type="submit" variant="primary" class="mt-4">Guardar</b-button>
              <b-button :to="{ name: 'areas'}" variant="danger" class="mt-4">Cancelar</b-button>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import Multiselect from 'vue-multiselect'
import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';

export default {
  data() {
    return {
      nameArea: '',
      hospitalId: '',
      token: '',
      user: '',
      success: '',
      error: '',
      hospitalList: [],
      hospitals: [],
      modelsCollab: [],
      models: [],
      arrayJackets: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Hombre',
          type: 'Chamarra',
      }],
      arrayCoat: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Hombre',
          type: 'Bata'
      },{
          model: '',
          id: 2,
          color: '',
          gender: 'Hombre',
          type: 'Bata'
      }],
      arrayScrubs: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Hombre',
          type: 'Filipina'
      }],
      arrayPants: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Hombre',
          type:'Pantalon'
      }],
      arrayCaps: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Hombre',
          type:'Gorro'
      }],
      arrayShoes: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Hombre',
          type:'Calzado'
      }],
      arrayJacketsW: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Mujer',
          type: 'Chamarra',
      }],
      arrayCoatW: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Mujer',
          type: 'Bata'
      },
      {
          model: '',
          id: 2,
          color: '',
          gender: 'Mujer',
          type: 'Bata'
      }],
      arrayScrubsW: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Mujer',
          type: 'Filipina'
      }],
      arrayPantsW: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Mujer',
          type:'Pantalon'
      }],
      arrayCapsW: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Mujer',
          type:'Gorro'
      }],
      arrayShoesW: [{
          model: '',
          id: 1,
          color: '',
          gender: 'Mujer',
          type:'Calzado'
      }],
      currentPage: 1,
      pageSize: 10,
      reload: 0
    }
  },
  components: {
    Multiselect,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    pagedTableData() {
      return this.modelsCollab.slice(this.pageSize * this.currentPage - this.pageSize, this.pageSize * this.currentPage)
    }
  },
  methods: {
    updateProfile() {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')

      let array_model = []
        array_model = this.arrayJackets.concat(this.arrayScrubs, this.arrayPants, this.arrayCoat,this.arrayJacketsW, this.arrayScrubsW, this.arrayPantsW, this.arrayCoatW, this.arrayShoes, this.arrayShoesW, this.arrayCaps, this.arrayCapsW)
        array_model = array_model.filter((x) =>
            x.model != 0 || x.model != '')


      let formData = new FormData()
      formData.append('api_token', this.token)
      formData.append('user_id', this.user)
      formData.append('option', 'edit_area')
      formData.append('a_id', this.$route.params.areasId)
      formData.append('a_name', this.nameArea)
      formData.append('h_id', this.hospitalList[0] ? this.hospitalList[0].id : this.hospitalList.id)
      if(array_model.length)
        formData.append('items_array', JSON.stringify(array_model))

      axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        },
      )
      .then((response) => {
        if (!response.data.error.code) {
          this.success = true
        } else {
          this.success = false
          this.error = response.data.error.description
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    hasClothesType: function  (gender){
        if (gender) {
            let elements = {
                scrub: [],
                pants: [],
                coat: [],
                jacket: [],
                shoes: [],
                caps: []
            }

            if (gender == 'Hombre') {
                elements.scrub =  this.models.filter((x) => x.type_id == '2' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
                elements.pants = this.models.filter((x) => x.type_id == '3' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
                elements.coat = this.models.filter((x) => x.type_id == '5' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
                elements.jacket  = this.models.filter((x) => x.type_id == '4' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
                elements.shoes  = this.models.filter((x) => x.type_id == '6' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
                elements.caps  = this.models.filter((x) => x.type_id == '7' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
            } else {
                elements.scrub =  this.models.filter((x) => x.type_id == '2' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
                elements.pants = this.models.filter((x) => x.type_id == '3' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
                elements.coat = this.models.filter((x) => x.type_id == '5' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
                elements.jacket  = this.models.filter((x) => x.type_id == '4' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
                elements.shoes  = this.models.filter((x) => x.type_id == '6' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
                elements.caps  = this.models.filter((x) => x.type_id == '7' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
            }
            return elements
        } else {
            return {
                scrub: [],
                pants: [],
                coat: [],
                jacket: [],
                shoes: [],
                caps: []
            }
        }
    },
    getColors(index){
        if (index) {
            return this.models.filter((x) => x.name == index).map(y => y.sharedColor)[0].map(z => z.name)
        } else {
            return ''
        }
    },
    setPage (val) {
      this.currentPage = val
    },
    deleteElement(index){
        this.token = localStorage.getItem('token')
        this.user = localStorage.getItem('id_user')
        var position = this.modelsCollab.findIndex(x => x.id === index)
        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
          qs.stringify({
            api_token: this.token,
            user_id: this.user,
            option: 'delete_itemcollab',
            id: index}),
        )
        .then((response) => {
          console.log(response)
          if (!response.data.error.code) {
            this.reload++
            this.modelsCollab.splice(position, 1)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
  async created() {
    this.token = localStorage.getItem('token')
    this.user = localStorage.getItem('id_user')

    await axios
    .post(
      process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
      qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_catalogs'}),
    )
    .then((response) => {
      if (!response.data.error.code && response.data.hospitals) {
        let temp = [], tempModels = []
        Object.keys(response.data.hospitals).map((key) => [response.data.hospitals[key]]).map(function(value) {
            temp.push(value[0])
        })
        this.hospitals = temp
        Object.keys(response.data.models).map((key) => [response.data.models[key]]).map(function(value) {
          tempModels.push(value[0])
        })
        this.models = tempModels
      }
    })
    .catch((err) => {
      console.log(err)
    })

    await axios
    .post(
      process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
      qs.stringify({
        api_token: this.token,
        user_id: this.user,
        option: 'get_area',
        get_area: this.$route.params.areasId
      }),
    )
    .then((response) => {
      if (!response.data.error.code) {
        this.nameArea = response.data.area.name
        this.hospitalId = response.data.area.hospital_id
        this.hospitalList = response.data.area.hospital_id ? this.hospitals.filter((x) => { return x.id ? x.id === response.data.area.hospital_id : x }) : ''
        let temp = []
          Object.keys(response.data.item).map((key) => [response.data.item[key]]).map(function(value) {
              temp.push(value[0])
          })
        this.modelsCollab = temp
      }
    })
    .catch((err) => {
      console.log(err)
    })
  }
};
</script>
<style></style>
